module.exports = __webpack_public_path__ + "img/android-chrome-maskable-512x512.02a9136a.svg";